import { Component, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { AppState } from './core/app.states';
import { Store } from '@ngrx/store';
import { ClearStore } from 'auth';
import { Observable } from 'rxjs';
import { ObervableService } from './service/obervable.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent implements OnDestroy {

	public isCommitteeMember: boolean = null;
	public loader: boolean = false;
	public getState: Observable<any>;

	constructor(private store: Store<AppState>, private cdref: ChangeDetectorRef, private obervableService: ObervableService) {
		this.getState = this.store.select('userInfoState');

		this.obervableService.showLoader.subscribe( value => {
			this.loader = value;
		});
	}

	ngOnDestroy() {
		this.store.dispatch(new ClearStore());
	}

	ngAfterViewInit() {

		this.getState.subscribe((state) => {
			this.isCommitteeMember = state.isCommitteeMember;
			this.cdref.detectChanges();
		});
	}
}
